module.exports = __webpack_public_path__ + "img/BE0418371094.4f408334.png";